module.exports = __webpack_public_path__ + "media/assets/faria_products/STN_MAINTENANCE-c8bbde2f268ab7648fb36ef0666957b9b93ee8ce5f30dbd35c22dbf73b8f6ac4.png";